// Placeholders for the standard static/compliance pages (Privacy Policy, About Us, etc.) -
// bound to /company/get_footer_pages, except Contact Us which has its own dedicated API.
export const STATIC_PAGE_PLACEHOLDERS = ['page_name', 'page_description'] as const;
export const CONTACT_PAGE_PLACEHOLDERS = ['phone_no', 'email', 'address', 'details'] as const;

// Single source of truth for the 6 standard static pages: maps the page id (used as
// activePageId/URL ?page= value) to its API slug, and flags the one page (Contact Us)
// that binds to a different endpoint entirely. Header.tsx seeds these into the Static
// Pages dropdown, Canvas.tsx fetches per-page data keyed off this, and RightSidebar.tsx
// uses it to decide which placeholders to offer.
export const STATIC_PAGE_REGISTRY: Record<string, { name: string; slug: string; isContactPage?: boolean }> = {
  PRIVACY_POLICY: { name: 'Privacy Policy', slug: 'privacy-policy' },
  CONTACT_US: { name: 'Contact Us', slug: 'contact-us', isContactPage: true },
  TERMS_OF_SERVICES: { name: 'Terms of Services', slug: 'terms-of-services' },
  ABOUT_US: { name: 'About Us', slug: 'about-us' },
  AFFILIATE_DISCLOSURE: { name: 'Affiliate Disclosure', slug: 'affiliate-disclosure' },
  DO_NOT_SELL_MY_PERSONAL_INFORMATION: { name: 'Do Not Sell My Personal Information', slug: 'do-not-sell-my-personal-information' },
};